export enum KrkVerificationFormStep {
  Init = 'init',
  Form = 'form',
  Finish = 'finish'
}

export enum KrkVerificationFormField {
  FullLegalCapacity = 'full_legal_capacity',
  NotConvicted = 'not_convicted',
  ProperAgencyPerformance = 'proper_agency_performance'
}
